<template>
  <!-- 下载 -->
  <div class="">
    <v-dialog
      class="del"
      name="dialog2"
      v-model="isShow"
      title="导出文件"
      close-on-click-modal
      :modal="true"
      :width="668"
      :height="274"
      @after-close="handleAfterClose"
      @confirm="handleConfirm"
      append-to-body
      confirmButtonText="确定"
    >
      确定导出此文件吗？
    </v-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props:{
    showInputDialog:{
      type:Boolean,
      default: false
    },
    row: {
    }
  },
  data() {
    return {
      isShow:false,
    };
  },
  created() {
  },
  watch:{
    showInputDialog(newVal){
      this.isShow = newVal
    }
  },
  methods: {
    async handleConfirm() {
      const subData = {
          app_id: sessionStorage.getItem("appid") || "",
          strategy_id: this.row.strategy_id
      }
    const res = await this.$getData("/td/td-iot-api/iot/upgrade/force/log/export", subData, false);
      let url = res.data.export_url
      let list = url.split('/')
      let name = list[list.length - 1]
      // 发送http请求，将文件链接转换成文件流
      let xhr = new XMLHttpRequest()
      xhr.open('get', url, true)
      // 请求类型
      xhr.responseType = 'blob'
      xhr.onreadystatechange = function() {
      	// 获取接口结果
          if (xhr.readyState === 4 && xhr.status === 200) {
            window.URL = window.URL || window.webkitURL
            let a = document.createElement('a')
            let blob = new Blob([xhr.response])
            // 通过二进制文件创建url
            let url = window.URL.createObjectURL(blob)
            a.href = url
            a.download = name
            a.click()
            // 销毁创建的url
            window.URL.revokeObjectURL(url)
          }
      }
      xhr.send()

    this.$emit('update:showInputDialog',false)
    },
    handleAfterClose() {
      this.$emit('update:showInputDialog',false)
    },
  },
  beforeDestroy() {},
};
</script>

<style lang="scss"></style>
